import brand from '@helpers/brand';
import svgCalendar from '@img/icons/background/calendarWhite.svg?url';
import styled, { css } from 'styled-components';
import { CommonTextInputStyles } from '../Textbox/Textbox.styles';
export const CommonDateWrapperStyles = css `
  --translateY: -50%;

  position: relative;

  &::after {
    content: '';
    display: inline-flex;
    align-items: center;
    width: 40px;
    height: 40px;
    position: absolute;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
    right: 6px;
    background-color: ${brand.secondary.purple.purple100};
    background-image: url(${svgCalendar});
    background-size: 35%;
    background-position: center;
    background-repeat: no-repeat;
    transform: translateY(var(--translateY));
    pointer-events: none;
  }
`;
const Container = styled.div `
  ${CommonDateWrapperStyles};
`;
const Input = styled.input `
  ${CommonTextInputStyles};

  &::-webkit-calendar-picker-indicator {
    opacity: 0;
  }
`;
const DateStyles = {
    Input,
    Container,
};
export default DateStyles;
